export const SET_STAKE_DATA = 'SET_STAKE_DATA'
export const SET_CURRENT_STATUS = 'SET_CURRENT_STATUS'

const initialState = {
  delegatorAddress: '',
  validatorAddress: '',
  validatorName: '',
  amount: '',
  validatorSrcAddress: '',
  validatorDstAddress: '',
  validatorDstName: '',
  status: '',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_STAKE_DATA:
      return { ...state, ...action.data }

    case SET_CURRENT_STATUS:
      return { ...state, status: action.data }

    default:
      return { ...state }
  }
}

export const actionSetStakeData = data => dispatch => dispatch({ type: SET_STAKE_DATA, data })

export const actionSetStatus = data => dispatch => dispatch({ type: SET_CURRENT_STATUS, data })
